<template>
  <v-container
    id="user-management"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        v-if="$can('read', 'userlist')"
        cols="12"
        md="8"
      >
        <base-material-card icon="mdi-account-outline">
          <template #after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ $t('usermanagment.userlist') }}
            </div>
          </template>

          <v-data-table
            :headers="tableHeader"
            :items="userList"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20, 25, -1]
            }"
            :items-per-page="10"
            class="elevation-0"
          >
            <template
              v-if="$can('write', 'userlist')"
              #body="{ items, headers }"
            >
              <tbody>
                <tr
                  v-for="(item,idx) in items"
                  :key="idx"
                >
                  <td
                    v-for="(header,key) in headers"
                    :key="key"
                  >
                    <span v-if="header.value === 'email'">
                      {{ item[header.value] }}
                    </span>
                    <v-edit-dialog
                      v-if="header.value !== 'email' && header.value !== 'action'"
                      :return-value.sync="item[header.value]"
                      large
                      @save="editUser(item)"
                    >
                      {{ item[header.value] }}
                      <template #input>
                        <v-text-field
                          v-model="item[header.value]"
                          label="Edit"
                          single-line
                        />
                      </template>
                    </v-edit-dialog>
                    <span class="showOnHover">
                      <v-icon
                        v-if="header.value === 'action' && $can('write', 'userlist')"
                        @click="blockUser(item)"
                      >mdi-trash-can-outline</v-icon>
                    </span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
      <v-col
        v-if="$can('write', 'userlist')"
        cols="12"
        md="8"
      >
        <base-material-card icon="mdi-account-outline">
          <template #after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ $t('usermanagment.adduser') }}
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="lastName"
                    class="purple-input"
                    :label="$t('usermanagment.lastname')"
                    @keyup.enter="addUser"
                    @input="isSaveButtonDisabled = false"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="firstName"
                    class="purple-input"
                    :label="$t('usermanagment.firstname')"
                    @keyup.enter="addUser"
                    @input="isSaveButtonDisabled = false"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="email"
                    class="purple-input"
                    :label="$t('usermanagment.email')"
                    :rules="[rules.email]"
                    @keyup.enter="addUser"
                    @input="isSaveButtonDisabled = false"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    :value="password"
                    class="purple-input"
                    :label="$t('usermanagment.password')"
                    :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="value ? 'password' : 'text'"
                    :rules="[rules.password]"
                    @keyup.enter="addUser"
                    @input="_=>password=_"
                    @click:append="() => (value = !value)"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-combobox
                    v-model="role"
                    hide-details
                    dense
                    outlined
                    :label="$t('usermanagment.rolelist')"
                    :items="roleList"
                    @input="isSaveButtonDisabled = false"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="customPhotoURL"
                    class="purple-input"
                    :label="$t('usermanagment.photourl')"
                    @keyup.enter="addUser"
                    @input="isSaveButtonDisabled = false"
                  />
                </v-col>
                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    color="success"
                    class="mr-0"
                    :disabled="isSaveButtonDisabled"
                    @click="addUser"
                  >
                    {{ $t('usermanagment.add') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      // userData: null,
      userList: [],
      roleList: ['master', 'marketing', 'support', 'changelog', 'blocked'],
      lastName: '',
      firstName: '',
      customPhotoURL: '',
      email: '',
      password: '',
      valid: true,
      value: true,
      role: '',
      isSaveButtonDisabled: true,
      rules: {
        required: value => !!value || 'Required.',
        password: value => {
          return (
            value.length > 5 ||
            'Min. 6 characters.'
          )
        },
        email: value => {
          // eslint-disable-next-line no-useless-escape
          return (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'E-mail is invalid')
        },
      },
    }),
    computed: {
      loading_userList () {
        return this.$store.state.user.loading_userList
      },
      tableHeader () {
        return [
          {
            text: this.$t('usermanagment.lastname'),
            value: 'lastName',
          },
          {
            text: this.$t('usermanagment.firstname'),
            value: 'firstName',
          },
          {
            text: this.$t('usermanagment.email'),
            value: 'email',
          },
          {
            text: this.$t('usermanagment.userrole'),
            value: 'role',
          },
          {
            text: '',
            value: 'action',
            width: '0',
          },
        ]
      },
    },
    watch: {
      loading_userList: {
        immediate: true,
        handler: function (value) {
          if (!value) {
            this.loadTable()
          }
        },
      },
    },
    mounted () {
      if (this.$can('read', 'userlist')) {
        this.$store.dispatch('ALL_USER_FETCH')
        this.loadTable()
      }
    },
    methods: {
      addUser () {
        // eslint-disable-next-line no-useless-escape
        const emailValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email)
        if (!this.password.length > 5 || !emailValid || !this.password) {
          console.log('invalid email or password')
          this.isSaveButtonDisabled = true
          return
        }
        if (!this.role) {
          this.role = 'support'
        }
        if (this.$can('write', 'userlist')) {
          this.$store.dispatch('USER_SIGNUP', {
            email: this.email,
            password: this.password,
            extraData: { lastName: this.lastName, firstName: this.firstName, role: this.role, customPhotoURL: this.customPhotoURL },
          }).then(() => {
            // TODO: prevent signup from logging in the new user automatically; for now, log out to prevent confusion
            setTimeout(() => {
              this.$store.dispatch('USER_SIGNOUT')
              this.clearForm()
              this.$router.replace('/pages/login')
            }, 2000)
          })
        }
        this.$store.state.user.loading_userList = true
        this.$store.dispatch('ALL_USER_FETCH')
      },
      editUser (user) {
        if (this.$can('write', 'userlist')) {
          this.$store.dispatch('SAVE_OTHER_USER_INFO', {
            userID: user.uid,
            userInfo: {
              lastName: user.lastName,
              firstName: user.firstName,
              role: user.role,
              email: user.email,
            },
          })
        }
      },
      blockUser (user) {
        user.role = 'blocked'
        this.editUser(user)
      },
      clearForm () {
        this.lastName = ''
        this.firstName = ''
        this.customPhotoURL = ''
        this.email = ''
        this.password = ''
        this.role = ''
        this.isSaveButtonDisabled = true
      },
      loadTable () {
        this.userList = []
        if (this.$can('read', 'userlist')) {
          if (this.$store.state.user.all_users) {
            const users = this.$store.state.user.all_users
            users.forEach(user => {
              this.userList.push({
                lastName: user.lastName,
                firstName: user.firstName,
                email: user.email,
                role: user.role,
                uid: user.uid,
                action: '',
              })
            })
          }
        }
      },
    },
  }
</script>

<style scoped lang="scss">
.showOnHover{
  .v-icon {
    //color: transparent;
    color: #D3D3D3;
      &:hover {
        color: red;
    }
  }
}

</style>
